
// import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Skeleton from "@mui/material/Skeleton";
import { useTheme } from "@mui/material/styles";
import { count, getSetting, isDefined } from "../../config/helpers";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";
import useWindowSize from "../../_hooks/useWindowSize";

import CategoryPageLoader from "./CategoryPageLoader";
import { useCategoryContext } from "../Providers/CategoryContext";

const PageHead = dynamic(() => import("../Reusables/PageHead"));
const BoxContainer = dynamic(() => import("../Reusables/BoxContainerV2"));

const CategorySliderContainer = dynamic(() => import("./CategoryHeading/CategorySliderContainer"), {
    loading: () => (
        <>
            <Skeleton variant="rectangle" sx={{display: {xs: 'none', lg: 'block'}, padding: 0, margin: 1, height: 250}} />
            <Skeleton sx={{margin: 1}}/>
            <Skeleton sx={{margin: 1}}/>
        </>
    )
    , ssr:true
});

const SubCategoryList  = dynamic(() => import("./CategoryHeading/SubCategoryList"));
const CategorySchema  = dynamic(() => import("../Schemas/CategorySchema"));
const CategorySelectedFilters  = dynamic(() => import("./Filters/CategorySelectedFilters"), {ssr: false});
const CategorySortAndFilters  = dynamic(() => import("./Filters/CategorySortAndFilters"));
const CategoryDescriptions  = dynamic(() => import("./CategoryHeading/CategoryDescriptions"));

const CategoryProducts = dynamic(() => import("./Products/CategoryProducts"), {
        loading: (e) => <CategoryPageLoader />
    }
);
// const CategorySortAndFilters  = dynamic(() => import("./Filters/CategorySortAndFilters"));
const CategoryLongDescription = dynamic(() => import("./CategoryLongDescription"));


const Category = ({ categoryData, loading }) => {
    //categoryData
    //selected_sort_name - property of categoryData
    const {
        long_term,
        template_page_settings,
    } = categoryData;


    const {template_settings, pageSpinner} = useSelector((state) => state.globalReducer);
    const {categoryState, categoryLoaders} = useSelector((state) => state.categoryReducer);
    

    //constants
    const theme = useTheme();
    const {isMobile} = useWindowSize();

    const {
        loadingProducts,
        selected_category_filters,
        categoryProducts,
        catData,
    } = useCategoryContext();

    const canonical_link = (process.env.brand.brand_id == 1 || !catData?.category?.slug) ? false : `${process.env.NEXT_PUBLIC_HOME_URL}/${catData.category.slug}`
    // useEffect(() => {
    //     updateData(categoryData); //TODO: manage this state
    // }, [categoryData])
    

    //layout setting retrieved from template settings
    const layout = getSetting(
        template_settings,
        template_page_settings,
        "layout",
        "wide"
    );

    const isLoading = (loadingProducts.current || loading || categoryLoaders?.fetchingCategory || pageSpinner);
    const className = (!isMobile && template_page_settings.page_class_type ? template_page_settings.page_class_type : 'pl-0 pr-0');
    

    // console.log(template_page_settings)
    
    //type is the key of the page setting which will result in the width, e.g 800px
    //layout width is only applicable for custom layout
    //if layout is custom then the layout width in the page settings is checked if it is not null use it 
    //else check for the brand custom layout width value use if not null else return 0px
    // const layout_width =
    //     layout == "custom"
    //         ? getSetting(
    //               template_settings,
    //               template_page_settings,
    //               "custom_layout_width",
    //               "0px"
    //           )
    //         : "0px";

    //item count style

    if(isDefined(catData.term) && catData?.term != "") return; //Wait to load category if coming from search

    return (
        <>
            <PageHead 
                title={catData.category.meta_title}
                content={catData.category.meta_description}
                keywords={catData.category.meta_keywords}
                link={canonical_link}
            />

            <BoxContainer id="category_page" className={className}>
                {/* {addLayout(toWrapComponents, layout, layout_width)} */}
                <CategorySchema
                    categoryData={catData}
                    category_products={categoryProducts}
                    long_term={long_term}
                />

               {!isMobile && <CategorySliderContainer 
                    slides={catData.slides}
                    loading={isLoading}
                />}

                {isDefined(catData.category.subtitle) && isDefined(catData.category.description_short) && (
                    <CategoryDescriptions
                        subtitle={catData.category.subtitle}
                        description={catData.category.description_short}
                        loading={isLoading}
                    />
                )}

                <>
                    {isDefined(catData.category.sons) && count(catData.category.sons) > 0 && (
                        <SubCategoryList sons={catData.category.sons} />
                    )}
          
                </>
                <CategorySortAndFilters
                    in_drawer={true}
                    filter_width={"250px"}
                />
                <Divider className="mt-2 mb-2"/>

                {selected_category_filters &&  Object.keys(selected_category_filters).length > 0 && (
                        <CategorySelectedFilters
                            theme={theme}
                        />
                    )
                }

                <CategoryProducts
                    loadingProducts={isLoading}
                    products={categoryProducts}
                    template_page_settings={template_page_settings}
                    long_term={long_term}
                    props={catData}
                    source="category"
                />
                
                <CategoryLongDescription 
                    layout={layout}
                    long_desc={catData.long_desc}
                    isMobile={isMobile}
                />
            </BoxContainer>
        </>
        );
};

export default Category;
